<template>
    <div
        class="rubric-feedback"
        v-if="edit">
        <b-textarea
            class="apprentice-textarea"
            v-model="feedback"
            :placeholder="$t('rubrics.give_feedback')"
            rows="4"
            max-rows="4">
        </b-textarea>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-feedback-input-component',
    props: {
        edit: Boolean,
        feedbackIn: String,
    },
    data() {
        return {
            feedback: this.feedbackIn,
        };
    },
    watch: {
        feedback() {
            this.$emit('update-feedback', this.feedback);
        },
        feedbackIn() {
            this.feedback = null;
            this.feedback = this.feedbackIn;
        },
    },
};
</script>

<style scoped lang="scss"></style>
